import { navigationArrival } from '~/utils/siteClock'

export default ({ store }) => {
  const siteNow = store.state.clock_now
  if (!Number.isFinite(siteNow)) return

  store.commit(
    'SET_CLOCK_OFFSET',
    siteNow - navigationArrival(window.performance, Date.now())
  )
}
